export const referencesConstants = {
    START: 'references:start',
    STOP: 'references:stop',
    LIST: 'references:list',
    ADD: 'references:add',
    UPDATE: 'references:update',
    REMOVE: 'references:delete',
    CLEAR: 'references:clear',
};